@if (content) {
<modal-layout-middle class="flex flex-justify-center flex-middle">
    <!-- close button -->
    <button class="pos-absolute flex flex-middle z-1 left-4 top-6 b-radius-max p-a bg-col-w cursor-pointer _close-btn"
            type="button"
            (click)="close()"
            aria-label="Close modal window">
        <i class="flex flex-middle fs-3 icon-close"
           aria-hidden="true"></i>
        <span class="flex flex-middle h4 p-l-3"
              *iCms="'btnCopy' of content"></span>
    </button>
    <!-- image -->
    <div class="ratio-1-1 _img-wrap"
         (offClick)="close()">
        <img class="rf"
             [image]="data" />
    </div>
</modal-layout-middle>
}